import React, { useEffect, useState } from 'react'
import Header from '../../../components/Header/Header'
import { AppBody, AppContainer, AppBodyBailleur, AppContent } from '../../../styles/App.styled';
import { connect } from 'react-redux';
import * as actions from '../../../store/actions/index';
import { Navigate, Route, useLocation, Routes, useNavigate } from 'react-router-dom';
import Menu from '../../Menu/Menu'
import HomeIcon from '@mui/icons-material/Home';
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import BadgeIcon from '@mui/icons-material/Badge';
import ArticleIcon from '@mui/icons-material/Article';
import SaveIcon from '@mui/icons-material/Save';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { useTranslation } from 'react-i18next';

import EnqueteDeSatisfaction from '../../EnqueteDeSatisfaction/EnqueteDeSatisfaction';

// import WalletIcon from '@mui/icons-material/Wallet';

function LocataireRoot({ userRoles, userType, URL }) {
  
    return (
        <>
            <AppContainer style={{ padding: "2rem 2rem" }}>
                <div style={{ display: "flex", justifyContent: "center", height: "100px", alignItems: "center" }}>

                    <Header isEnqueteSatisfaction={true} />

                </div>
                <AppBodyBailleur>  
                   
                    <AppContent >
                        <Routes>   
                            <Route path="/" element={<EnqueteDeSatisfaction />} />
                        </Routes>
                    
                    </AppContent>
                </AppBodyBailleur>
            </AppContainer>
            
        </>
    )

}





const mapStateToProps = state => {
    return {
        userType: state.auth.userType,
        logo: state.auth.logo,
        URL: state.auth.URL,
    }
}
const mapDispatchToProps = dispatch => {
    return {

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LocataireRoot);

